module.exports = __webpack_public_path__ + "img/INTERIOR-FRONX-BOOSTERGREEN-2.9a5c9596.jpg";